import { factoryLoading, ILoadingState, LoadingStateType } from '@adex/shared/models/states/loading.state'


export class LoadingStateCreator {
  private static state: ILoadingState
  private static readonly excludeRequests = [
    'assets'
  ]

  public static create(urls: object): ILoadingState {
    this.state = {}
    this.scan(urls)
    return this.state
  }

  public static checkInBlackList(url): boolean {
    return this.excludeRequests.some(v => url.includes(v))
  }

  private static scan(obj: object | string | ((s: string) => string)): void {
    if (typeof obj === 'function') return this.anchor(obj(''))
    if (typeof obj === 'string') return this.anchor(obj)
    if (!obj) return
    const keys = Object.keys(obj)
    for (let i = 0; i <= keys.length; i++) {
      const key = keys[i]
      this.scan(obj[key])
    }
  }

  private static anchor(key: string): void {
    this.state[key] = factoryLoading(LoadingStateType.default)
  }

}
